/*
 * Public API Surface of ng-snotify
 */

export * from './lib/snotify.module';
